import { COLORS } from 'constants/colors'
import styled from 'styled-components'

export const Container = styled.div`
  cursor: pointer;
  display: flex;
  user-select: none;
  color: ${COLORS.gray28};
  align-items: center;
  margin-right: 16px;
`

export const Label = styled.label`
  margin-left: 8px;
  cursor: pointer;
`
